module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp12_8017.d1bd159f.png";